import styled from "styled-components";

export const TooltipContentBox = styled.div`
    padding: 10px;
    max-height: 640px;
    overflow-y: auto;
 `;